export enum RenderingMode {
    CaseSubmission,
    Genie,
    DiagnoseAndSolve,
    AppLens
}
